import React from "react";
import Field from "../../sections/shared/Field";
import EditorGroup from "../../sections/shared/EditorGroup";

function normalizeGalleryTemplate(template) {
  const t = String(template || "").toLowerCase().trim();

  if (t === "1" || t === "gallery1" || t === "template1" || t.endsWith("gallery1")) return "gallery1";
  if (t === "2" || t === "gallery2" || t === "template2" || t.endsWith("gallery2")) return "gallery2";
  if (t === "3" || t === "gallery3" || t === "template3" || t.endsWith("gallery3")) return "gallery3";

  return "";
}

export default function GalleryDesignSection({
  editedSection,
  t,
  flags,
  onStyleChange,
}) {
  const { isGallery } = flags;
  const templateKey = normalizeGalleryTemplate(editedSection?.template);

  const isGallery1 = isGallery && templateKey === "gallery1";
  const isGallery2 = isGallery && templateKey === "gallery2";
  const isGallery3 = isGallery && templateKey === "gallery3";

  if (!isGallery1 && !isGallery2 && !isGallery3) return null;

  return (
    <>
      <EditorGroup
        title={t("sectionModal.galleryShared.title", "Gallery Colors")}
        subtitle={t("sectionModal.galleryShared.help", "Shared gallery card and overlay colors")}
        defaultOpen={false}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field
            label={t("sectionModal.galleryShared.cardBg", "Card Background")}
            type="color"
            value={editedSection?.style?.galleryCardBg}
            onChange={(v) => onStyleChange("galleryCardBg", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.cardBorder", "Card Border")}
            type="color"
            value={editedSection?.style?.galleryCardBorder}
            onChange={(v) => onStyleChange("galleryCardBorder", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.cardTitleColor", "Card Title Color")}
            type="color"
            value={editedSection?.style?.galleryCardTitleColor}
            onChange={(v) => onStyleChange("galleryCardTitleColor", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.cardDescriptionColor", "Card Description Color")}
            type="color"
            value={editedSection?.style?.galleryCardDescriptionColor}
            onChange={(v) => onStyleChange("galleryCardDescriptionColor", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.overlayColor", "Overlay Color")}
            type="color"
            value={editedSection?.style?.galleryOverlayColor}
            onChange={(v) => onStyleChange("galleryOverlayColor", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.overlayTextColor", "Overlay Text Color")}
            type="color"
            value={editedSection?.style?.galleryOverlayTextColor}
            onChange={(v) => onStyleChange("galleryOverlayTextColor", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.badgeBg", "Badge Background")}
            type="color"
            value={editedSection?.style?.galleryBadgeBg}
            onChange={(v) => onStyleChange("galleryBadgeBg", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.badgeTextColor", "Badge Text Color")}
            type="color"
            value={editedSection?.style?.galleryBadgeTextColor}
            onChange={(v) => onStyleChange("galleryBadgeTextColor", v)}
          />
          <Field
            label={t("sectionModal.galleryShared.emptyStateColor", "Empty State Color")}
            type="color"
            value={editedSection?.style?.galleryEmptyStateColor}
            onChange={(v) => onStyleChange("galleryEmptyStateColor", v)}
          />
        </div>
      </EditorGroup>

      {isGallery1 && (
        <EditorGroup
          title={t("sectionModal.gallery1.title", "Gallery Template 1")}
          subtitle={t("sectionModal.gallery1.help", "Stats cards and modal styling")}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.gallery1.statsCardBg", "Stats Card Background")}
              type="color"
              value={editedSection?.style?.galleryStatsCardBg}
              onChange={(v) => onStyleChange("galleryStatsCardBg", v)}
            />
            <Field
              label={t("sectionModal.gallery1.statsCardBorder", "Stats Card Border")}
              type="color"
              value={editedSection?.style?.galleryStatsCardBorder}
              onChange={(v) => onStyleChange("galleryStatsCardBorder", v)}
            />
            <Field
              label={t("sectionModal.gallery1.statsValueColor", "Stats Value Color")}
              type="color"
              value={editedSection?.style?.galleryStatsValueColor}
              onChange={(v) => onStyleChange("galleryStatsValueColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.statsLabelColor", "Stats Label Color")}
              type="color"
              value={editedSection?.style?.galleryStatsLabelColor}
              onChange={(v) => onStyleChange("galleryStatsLabelColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalBg", "Modal Background")}
              type="color"
              value={editedSection?.style?.galleryModalBg}
              onChange={(v) => onStyleChange("galleryModalBg", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalTitleColor", "Modal Title Color")}
              type="color"
              value={editedSection?.style?.galleryModalTitleColor}
              onChange={(v) => onStyleChange("galleryModalTitleColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalCategoryColor", "Modal Category Color")}
              type="color"
              value={editedSection?.style?.galleryModalCategoryColor}
              onChange={(v) => onStyleChange("galleryModalCategoryColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalTextColor", "Modal Text Color")}
              type="color"
              value={editedSection?.style?.galleryModalTextColor}
              onChange={(v) => onStyleChange("galleryModalTextColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalFeatureBoxBg", "Feature Box Background")}
              type="color"
              value={editedSection?.style?.galleryModalFeatureBoxBg}
              onChange={(v) => onStyleChange("galleryModalFeatureBoxBg", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalFeatureBoxBorder", "Feature Box Border")}
              type="color"
              value={editedSection?.style?.galleryModalFeatureBoxBorder}
              onChange={(v) => onStyleChange("galleryModalFeatureBoxBorder", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalFeatureTitleColor", "Feature Title Color")}
              type="color"
              value={editedSection?.style?.galleryModalFeatureTitleColor}
              onChange={(v) => onStyleChange("galleryModalFeatureTitleColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.modalFeatureTextColor", "Feature Text Color")}
              type="color"
              value={editedSection?.style?.galleryModalFeatureTextColor}
              onChange={(v) => onStyleChange("galleryModalFeatureTextColor", v)}
            />
            <Field
              label={t("sectionModal.gallery1.secondaryBtnBg", "Secondary Button Background")}
              type="color"
              value={editedSection?.style?.gallerySecondaryBtnBg}
              onChange={(v) => onStyleChange("gallerySecondaryBtnBg", v)}
            />
            <Field
              label={t("sectionModal.gallery1.secondaryBtnBorder", "Secondary Button Border")}
              type="color"
              value={editedSection?.style?.gallerySecondaryBtnBorder}
              onChange={(v) => onStyleChange("gallerySecondaryBtnBorder", v)}
            />
            <Field
              label={t("sectionModal.gallery1.secondaryBtnText", "Secondary Button Text")}
              type="color"
              value={editedSection?.style?.gallerySecondaryBtnText}
              onChange={(v) => onStyleChange("gallerySecondaryBtnText", v)}
            />
          </div>
        </EditorGroup>
      )}

      {isGallery2 && (
        <EditorGroup
          title={t("sectionModal.gallery2.title", "Gallery Template 2")}
          subtitle={t("sectionModal.gallery2.help", "Filter buttons and masonry overlay colors")}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.gallery2.filterActiveBg", "Active Filter Background")}
              type="color"
              value={editedSection?.style?.galleryFilterActiveBg}
              onChange={(v) => onStyleChange("galleryFilterActiveBg", v)}
            />
            <Field
              label={t("sectionModal.gallery2.filterActiveText", "Active Filter Text")}
              type="color"
              value={editedSection?.style?.galleryFilterActiveText}
              onChange={(v) => onStyleChange("galleryFilterActiveText", v)}
            />
            <Field
              label={t("sectionModal.gallery2.filterInactiveBg", "Inactive Filter Background")}
              type="color"
              value={editedSection?.style?.galleryFilterInactiveBg}
              onChange={(v) => onStyleChange("galleryFilterInactiveBg", v)}
            />
            <Field
              label={t("sectionModal.gallery2.filterInactiveText", "Inactive Filter Text")}
              type="color"
              value={editedSection?.style?.galleryFilterInactiveText}
              onChange={(v) => onStyleChange("galleryFilterInactiveText", v)}
            />
            <Field
              label={t("sectionModal.gallery2.filterInactiveBorder", "Inactive Filter Border")}
              type="color"
              value={editedSection?.style?.galleryFilterInactiveBorder}
              onChange={(v) => onStyleChange("galleryFilterInactiveBorder", v)}
            />
          </div>
        </EditorGroup>
      )}

      {isGallery3 && (
        <EditorGroup
          title={t("sectionModal.gallery3.title", "Gallery Template 3")}
          subtitle={t("sectionModal.gallery3.help", "Hero result cards, thumbnails, and labels")}
          defaultOpen={false}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Field
              label={t("sectionModal.gallery3.mainTextColor", "Main Text Color")}
              type="color"
              value={editedSection?.style?.galleryMainTextColor}
              onChange={(v) => onStyleChange("galleryMainTextColor", v)}
            />
            <Field
              label={t("sectionModal.gallery3.resultCardBg", "Result Card Background")}
              type="color"
              value={editedSection?.style?.galleryResultCardBg}
              onChange={(v) => onStyleChange("galleryResultCardBg", v)}
            />
            <Field
              label={t("sectionModal.gallery3.resultCardBorder", "Result Card Border")}
              type="color"
              value={editedSection?.style?.galleryResultCardBorder}
              onChange={(v) => onStyleChange("galleryResultCardBorder", v)}
            />
            <Field
              label={t("sectionModal.gallery3.resultValueColor", "Result Value Color")}
              type="color"
              value={editedSection?.style?.galleryResultValueColor}
              onChange={(v) => onStyleChange("galleryResultValueColor", v)}
            />
            <Field
              label={t("sectionModal.gallery3.resultLabelColor", "Result Label Color")}
              type="color"
              value={editedSection?.style?.galleryResultLabelColor}
              onChange={(v) => onStyleChange("galleryResultLabelColor", v)}
            />
            <Field
              label={t("sectionModal.gallery3.thumbActiveBorder", "Active Thumbnail Border")}
              type="color"
              value={editedSection?.style?.galleryThumbActiveBorder}
              onChange={(v) => onStyleChange("galleryThumbActiveBorder", v)}
            />
            <Field
              label={t("sectionModal.gallery3.thumbOverlayColor", "Thumbnail Overlay Color")}
              type="color"
              value={editedSection?.style?.galleryThumbOverlayColor}
              onChange={(v) => onStyleChange("galleryThumbOverlayColor", v)}
            />
            <Field
              label={t("sectionModal.gallery3.moreProjectsLabelColor", "More Projects Label Color")}
              type="color"
              value={editedSection?.style?.galleryMoreProjectsLabelColor}
              onChange={(v) => onStyleChange("galleryMoreProjectsLabelColor", v)}
            />
          </div>
        </EditorGroup>
      )}
    </>
  );
}